import React from "react";
import "./circularProgress.scss";
const CircularProgress = ({ percentage = 0, cancelled = false }) => {
    const safePercentage = Number.isFinite(Number(percentage))
        ? Math.max(0, Math.min(100, Number(percentage)))
        : 0;
    const size = 36;
    const radius = (size - 8) / 2;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference - (safePercentage / 100) * circumference;
    const strokeWidth = 3;
    const fontSize = 10;
    return (
        <div
            className={`circular-progress ${cancelled ? "is-cancelling" : ""}`}
            style={{ width: size, height: size }}
        >
            <svg viewBox={`0 0 ${size} ${size}`}>
                <circle
                    className="background"
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    style={{ strokeWidth }}
                />
                <circle
                    className="progress"
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    style={{
                        strokeDasharray: circumference,
                        strokeDashoffset: strokeDashoffset,
                        strokeWidth,
                    }}
                />
            </svg>
            {
                !cancelled ? <>
                    <div className="percentage" style={{ fontSize }}>{Math.floor(safePercentage)}%</div>
                    <div className="cross" style={{
                        width: size * 0.3,
                        height: size * 0.3
                    }}>
                    </div>
                </> : <div className="cancel-spinner"></div>
            }


        </div>
    );
};
export default CircularProgress;